<template>
  <v-container fluid>
    <v-layout xs12 align-start row wrap>
      <v-flex xs12 sm12 md12 justify-center>
        <h2 class="ml-2 mb-2">Lista de Categorias</h2>
        <v-data-table
          :headers="headers"
          :items="$apollo.data.categories"
          :loading="$apollo.loading"
          item-key="id"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <div class="md8 mr-11 ml-2 row sm10 xs10">
                <v-flex xs3 sm3 md3>
                  <v-text-field
                    v-model="filters.name"
                    flat
                    hide-details
                    label="Nome"
                  ></v-text-field>
                </v-flex>
                <v-flex xs3 sm3 md3>
                  <v-text-field
                    v-model="filters.description"
                    flat
                    hide-details
                    label="Descrição"
                  ></v-text-field>
                </v-flex>
                <v-flex xs3 sm3 md3>
                  <v-autocomplete
                    v-if="listCategories"
                    label="Categoria Pai"
                    @keyup.delete="filters.parent_id = null"
                    v-bind:items="toArray(listCategories)"
                    item-value="id"
                    item-text="name"
                    v-model="filters.parent_id"
                  ></v-autocomplete>
                </v-flex>
              </div>
              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2" v-on="on"
                    >Adicionar</v-btn
                  >
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-flex xs12 sm12 md12>
                        <v-text-field
                          v-model="editedItem.name"
                          label="Nome"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <ApolloQuery
                          :query="
                            gql => gql`
                              query ListCategories {
                                categories(
                                  where: { isenabled: { _eq: true } }
                                  order_by: { name: asc }
                                ) {
                                  name
                                  id
                                }
                              }
                            `
                          "
                        />
                        <v-autocomplete
                          v-if="listCategories"
                          v-model="editedItem.parent_id"
                          v-bind:items="toArray(listCategories)"
                          @keyup.delete="editedItem.parent_id = null"
                          label="Categoria Pai"
                          item-text="name"
                          item-value="id"
                        >
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-textarea
                          v-model="editedItem.description"
                          label="Descrição"
                        ></v-textarea>
                      </v-flex>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="blue darken-1" text @click="close"
                      >Cancelar</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="save"
                      >Salvar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
            <v-icon small @click="deleteItem(item)">delete</v-icon>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {
  GetCategories,
  DeleteCategories,
  InsertCategories,
  UpdateCategories
} from "../../graphql/categories.gql";

export default {
  name: "categories-list",
  data: () => ({
    dialog: false,
    listCategories: [""],
    filters: [
      { name: null },
      { description: null },
      { parent_id: null },
      { isenabled: true }
    ],
    headers: [
      { text: "Nome", value: "name" },
      { text: "Descrição", value: "description" },
      { text: "Categoria pai", value: "category.name" },
      { text: "Ações", value: "action", sortable: false }
    ],
    editedIndex: -1,
    editedItem: {
      id: null,
      name: "",
      description: "",
      parent_id: null,
      showmainmenu: true,
      isenabled: true,
      order: null,
      category: [],
      categories: []
    },
    defaultItem: {
      id: null,
      name: "",
      description: "",
      parent_id: null,
      showmainmenu: true,
      isenabled: true,
      order: null,
      category: [],
      categories: []
    }
  }),

  apollo: {
    categories: {
      pollInterval: 1000,
      query: GetCategories,
      variables() {
        return {
          name: this.filters.name
            ? { _ilike: "%" + this.filters.name + "%" }
            : {},
          description: this.filters.description
            ? { _ilike: "%" + this.filters.description + "%" }
            : {},
          parent_id: this.filters.parent_id
            ? { _eq: this.filters.parent_id }
            : {},
          isenabled: this.filters.isenabled
            ? { _eq: this.filters.isenabled }
            : {}
        };
      }
    }
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nova Categoria" : "Editar Categoria";
    }
  },

  mounted: function() {
    this.$apollo
      .query({
        query: GetCategories,
        fetchPolicy: "network-only"
      })
      .then(data => {
        if (data.data.categories) {
          this.listCategories = [];
          this.listCategories = data.data.categories;
        }
      });
  },

  watch: {
    "$apollo.data.categories": {
      deep: true,
      handler() {
        this.$apollo
          .query({
            query: GetCategories,
            fetchPolicy: "network-only"
          })
          .then(data => {
            if (data.data.categories) {
              this.listCategories = [];
              this.listCategories = data.data.categories;
            }
          });
      }
    },
    dialog(val) {
      val || this.close();
    },
    "filters.name": {
      deep: true,
      handler(val) {
        if (typeof val !== "undefined" && val !== null) {
          if (val.length == 0) {
            this.filters.name = null;
          }
        }
      }
    },
    "filters.description": {
      deep: true,
      handler(val) {
        if (typeof val !== "undefined" && val !== null) {
          if (val.length == 0) {
            this.filters.description = null;
          }
        }
      }
    },
    "filters.parent_id": {
      deep: true,
      handler(val) {
        if (typeof val !== "undefined" && val !== null) {
          if (val.length == 0) {
            this.filters.parent_id = null;
          }
        }
      }
    }
  },

  methods: {
    clear(value) {
      if (!value) {
        return null;
      }
    },

    editItem(item) {
      this.editedIndex = this.$apollo.data.categories.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.$apollo.data.categories.indexOf(item);
      confirm("Deletar categoria?") &&
        this.$apollo
          .mutate({
            mutation: DeleteCategories,
            variables: {
              id: item.id
            }
          })
          .then(() => {
            this.$apollo.data.categories.splice(index, 1);
            this.$swal("Categoria deletada com sucesso!", "", "success");
          })
          .catch(() => {
            this.$swal("Erro ao deletar categoria!", "", "error");
          });
    },

    close() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },

    save() {
      this.$apollo
        .mutate({
          // Query
          mutation:
            this.editedItem.id !== null ? UpdateCategories : InsertCategories,
          // Parameters
          variables: {
            id: this.editedItem.id,
            name: this.editedItem.name,
            description: this.editedItem.description,
            parent_id: this.editedItem.parent_id,
            isenabled: this.editedItem.isenabled,
            showmainmenu: this.editedItem.parent_id !== null ? false : true
          }
        })
        .then(data => {
          if (this.editedItem.id !== null) {
            Object.assign(
              this.$apollo.data.categories[this.editedIndex],
              data.data.update_categories.returning[0]
            );
          } else {
            this.$apollo.data.categories.push(
              data.data.insert_categories.returning[0]
            );
          }

          this.close();
          this.$swal("Categoria salva com sucesso!", "", "success");
        })
        .catch(() => {
          this.close();
          this.$swal("Erro ao salvar a categoria!", "", "error");
        });
    },

    toArray(array) {
      let items = [];
      if (typeof array !== "undefined") {
        array.forEach(v => items.push(v));
      }
      return items;
    }
  }
};
</script>

<style lang="stylus"></style>
